import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { IClient } from '@splitsoftware/splitio/types/splitio';
import { user } from '€slices/user/user-selectors';
import PostAuth from '../components/PostAuth';
import { getTokenExpired, validateAuthCookie, validatingTokenExpired } from '€slices/auth';
import Loading from '€components/Loading';
import PrivateRoute from '€components/PrivateRoute';
import { Routes } from '€lib/routing';
import { timedOut } from '€slices/network';
import Login from '€views/Login';
import PasswordRecovery from '€views/PasswordRecovery';
import ResetPassword from '€views/ResetPassword';
import SignUp from '€views/SignUp';
import FeatureFlagsContext from '€components/FeatureFlags/FeatureFlagsContext';
// import { initializeClient } from '€lib/featureFlags/initializeClient';

const App = () => {
    const $user = useSelector(user);
    const tokenExpired = useSelector(getTokenExpired);
    const loading = useSelector(validatingTokenExpired);
    const sessionTimeOut = useSelector(timedOut);
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [featureFlagsClient, setFeatureFlagsClient] = useState<IClient>(null);

    useEffect(() => {
        // (async () => {
        //     if ($user) {
        //         setFeatureFlagsClient(await initializeClient($user.email));
        //     }
        // })();

        // check for auth state
        (function validateAuth() {
            try {
                if (!$user && !tokenExpired && !sessionTimeOut) {
                    dispatch(validateAuthCookie());
                }
            } catch (error) {}
        })();
    }, [dispatch, $user, tokenExpired, sessionTimeOut]);

    useEffect(() => {
        if (window && document && document.body) {
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    if (loading) {
        return <Loading />;
    }

    return (
        <FeatureFlagsContext.Provider value={{ client: featureFlagsClient }}>
            <Switch>
                <Route path={Routes.Login}>
                    <Login />
                </Route>
                <Route path={Routes.PasswordRecovery}>
                    <PasswordRecovery />
                </Route>
                <Route path={Routes.ResetPassword}>
                    <ResetPassword />
                </Route>
                <Route path={Routes.SignUp}>
                    <SignUp />
                </Route>
                <PrivateRoute
                    authenticated={Boolean($user?.name)}
                    path={[
                        Routes.Dashboard,
                        Routes.UserProfile,
                        Routes.ApplicationsList,
                        Routes.ReferAClient,
                    ]}
                >
                    <PostAuth />
                </PrivateRoute>
                <Redirect from="/" to={Routes.Dashboard} />
                {sessionTimeOut && <Redirect to={Routes.Login} />}
            </Switch>
        </FeatureFlagsContext.Provider>
    );
};

export default App;
